import React from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import Breadcrumbs from "../../../../components/BreadCrumbs";
import { UIButton, UIPageFormFooter, UITextField } from "../../../../components/ui";
import PermissionsMatrix from "../../../Company-portal/TeamsPermissions/CreateRole/PermissionsMatrix";
import useAdminViewRole from "../hooks/useAdminViewRole";

import "../../../Company-portal/TeamsPermissions/CreateRole/CreateRole.scss";
import "../../../Company-portal/TeamsPermissions/ViewRole/ViewRole.scss";

const AdminViewRole = () => {
  const {
    copy,
    createCopy,
    breadcrumbList,
    role,
    loading,
    editing,
    updating,
    permissions,
    setPermissions,
    canEdit,
    enterEdit,
    cancelEdit,
    handleUpdate,
    roleName,
    isSystemRole,
    name,
    setName,
    setNameTouched,
    showNameError,
    trimmedName,
    isEditDirty,
  } = useAdminViewRole();

  if (loading || !role) {
    return null;
  }

  return (
    <div className="team-management create-role view-role">
      <div className="mt-24 view-role__header">
        <div className="view-role__heading">
          <Breadcrumbs list={breadcrumbList} BreadCrumbHasBackIcon={false} />
          <p className="create-role__subtitle">{copy.subtitle}</p>
        </div>
        {!editing && canEdit && (
          <UIButton
            variant="outlined"
            size="large"
            color="primary"
            startIcon={<EditOutlinedIcon sx={{ fontSize: 18 }} />}
            onClick={enterEdit}
          >
            {copy.editPermissions}
          </UIButton>
        )}
      </div>

      <div>
        <UITextField
          label={copy.roleNameLabel}
          name="roleName"
          required={editing && !isSystemRole}
          value={editing && !isSystemRole ? name : roleName}
          placeholder={createCopy.roleNamePlaceholder}
          onChange={(event) => setName(event.target.value)}
          onBlur={() => setNameTouched(true)}
          error={showNameError}
          helperText={showNameError ? createCopy.roleNameRequired : null}
          disabled={!editing || isSystemRole}
          classNames={{ root: "create-role__name-field mb-24" }}
        />

        <PermissionsMatrix
          value={permissions}
          onChange={setPermissions}
          copy={createCopy}
          readOnly={!editing}
        />
      </div>

      {editing && (
        <UIPageFormFooter
          cancelLabel={copy.cancel}
          submitLabel={copy.updatePermissions}
          onCancel={cancelEdit}
          onSubmit={handleUpdate}
          cancelDisabled={updating}
          submitDisabled={
            updating || !isEditDirty || (!isSystemRole && !trimmedName)
          }
          submitLoading={updating}
        />
      )}
    </div>
  );
};

export default AdminViewRole;
